import { IBenefitGroup } from '@epi-models/containers/ManageBenefitGroups';

export const selectBenefitGroups = (state): IBenefitGroup[] =>
  state.apiBenefitGroups.benefitGroups;

export const selectIsBenefitGroupsLoaded = (state): boolean =>
  state.apiBenefitGroups.isLoaded;

export const selectIsBenefitGroupsError = (state): boolean =>
  state.apiBenefitGroups.isError;
